export default __webpack_public_path__ + "static/media/screen_google_drive_03.aad4f6c0.png";